import Say from "../../features/Say";
import variables from "../variables";
import {notify} from "../features/functions";
import places from "../places/places";
import people from "./people";

class Man {
    constructor(id = "",
                name = "",
                surname = "",
                color = "",
                additional = {}) {
        this.id = id;
        this.name = name;
        this.surname = surname;
        this.color = color;
        this.messages = {};
        Object.keys(additional).map(prop => {this[prop] = additional[prop]});
    }

    setName(name = "") {
        this.name = name;
        variables[this.id].name = name;
    };

    getName() { return this.name };

    set(property="", value) {
        const oldValue = this[property];
        if (["relations", "corruption"].includes(property)) {
            if (value > 100) value = 100;
            if (value < 0) value = 0;
        }
        this[property] = value;
        variables[this.id][property] = value;
        if (property !== "where") {
            if (value > oldValue)
                notify(<span style={{color: "green"}}>{this.name} {property} + {value-oldValue}</span>);
            else
                notify(<span style={{color: "red"}}>{this.name} {property} - {oldValue-value}</span>);
        }
    }

    setLocation(placeID = "") {
        places.setCurrent(placeID);

        this.where = placeID;
    };

    say(what = "") {return <Say who={this}>{what}</Say>};

    sendNewMessage (messageID = "") {
        variables.wife.messages[this.id] ?
            variables.wife.messages[this.id] = [...variables.wife.messages[this.id], messageID] :
            variables.wife.messages.addNew(this.id, [messageID]);
        notify(`New message from ${this.name}. Check it in leftSide menu => ${people.wife.getName()} => Phone => Contacts`);
        variables.wife.newMessage = this.id;
    };
}

export default Man;